var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(-1.25 -2.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37249",
    "data-name": "Path 37249",
    d: "M1.25,8.765a.936.936,0,0,1,.837-1.01H24.413a.936.936,0,0,1,.837,1.01.936.936,0,0,1-.837,1.01H2.087A.936.936,0,0,1,1.25,8.765Zm4.465,10.77a.936.936,0,0,1,.837-1.01H8.785a1.027,1.027,0,0,1,0,2.019H6.552A.936.936,0,0,1,5.715,19.535Zm5.023,0a.936.936,0,0,1,.837-1.01h4.465a1.027,1.027,0,0,1,0,2.019H11.576A.936.936,0,0,1,10.738,19.535Z",
    transform: "translate(0 -0.99)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37250",
    "data-name": "Path 37250",
    d: "M3.668,5.094c-.474.455-.744,1.319-.744,3.221v8.891c0,1.9.269,2.766.743,3.219s1.386.713,3.374.707H19.457c1.988,0,2.9-.258,3.376-.716s.744-1.319.744-3.221V8.315c0-1.9-.269-2.766-.744-3.221s-1.392-.717-3.386-.717H7.043C5.055,4.377,4.146,4.636,3.668,5.094ZM2.491,3.94C3.5,2.972,5.069,2.755,7.043,2.755h12.4c1.98,0,3.551.217,4.562,1.184S25.25,6.421,25.25,8.315V17.2c0,1.894-.228,3.4-1.241,4.375s-2.578,1.185-4.553,1.185H7.044C5.07,22.76,3.5,22.546,2.491,21.58S1.25,19.1,1.25,17.206V8.315C1.25,6.42,1.478,4.91,2.491,3.94Z",
    transform: "translate(0 0)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e1e82d12ee3c7e83ae7dfae2b0cb7b81.svg";
export { ForwardRef as ReactComponent };